import React, { Component, Fragment } from 'react';
import './manageSkillPath.scss';
import { resetSkillPath, getCustomSkillPath, getSkills, getSearchSkill, checkSkillPathLength, createCustomSkillpath, createOwnSkillpath, activeSkillpath } from '../../../ActionCreators/AdminAction/manageSkillpathAction';
import { getPlans, showWarning, closeSubModal } from '../../../ActionCreators/AdminAction/accountAction';
import { clearErrors } from '../../../ActionCreators/errorAction';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import $ from 'jquery';
import { convertToDates } from '../../../utils/miscelleneous';
import Switch from 'react-switch';
import Modal from "react-bootstrap/Modal";
import Snackbar from '@mui/material/Snackbar';
import { TopicLoader } from '../../../Loader/loader';
import WarningModal from '../../../utils/Expiremodal/warningModal';

class ManageSkillPath extends Component {
    state = {
        isOpen: false,
        page: 1,
        isCreate: false,
        createSkillpath: true,
        type: null
    }

    componentDidMount = async () => {
        if (this.props.history.location.state.direct) {
            this.setState({
                isOpen: true,
                skillId: '',
                search: ''
            }, () => {
                this.props.getSkills();
            })
        } else {
            this.setState({
                skillId: this.props.history.location.state.details?._id,
                search: '',
                type: 'own'
            })
            await this.props.getPlans();
            await this.props.resetSkillPath();
            await this.props.getCustomSkillPath(this.props.history.location.state.details?._id);
        }
        this.setState({
            createSkillpath: this.props.plans?.features?.filter(el => el.feature === 'Create custom learning paths')[0]?.allow
        })
    }

    openSearchSkill = async () => {
        await this.props.getSkills();
        this.setState({
            isOpen: true
        })
        $('#suggestion-container').hide();
    }





    searchSkill = (val) => {
        $('#suggestion-container').show();
        this.setState({
            search: val
        }, () => {
            if (val === '') {
                this.setState({
                    skillId: '',
                    skillTitle: '',
                    type: null
                })
            } else {
                this.props.getSearchSkill(this.state.search);
            }
        })
    }

    selectSkill = (el) => {
        $('#suggestion-container').hide();
        this.setState({
            search: el.title,
            skillId: el._id,
            skillTitle: el.title
        })
    }

    selectTab = (type) => {
        console.log(type)
        this.setState({
            type
        })
    }

    createCustom = async () => {
        const res = await this.props.checkSkillPathLength(this.state.skillId);
        // const check = this.props.customSkillPaths?.filter(el => el.skill?._id === this.state.skillId)
        if (res.payload?.total > 0) {
            this.setState({
                isCreate: true
            })
        } else {
            this.redirectSkillTopic(this.state.type);
        }
    }

    redirectSkillTopic = async (type) => {
        let obj = {
            _id: this.state.skillId
        }
        if (type === 'clone') {
            await this.props.createCustomSkillpath(obj);
        } else {
            this.setState({
                isOpen: false, search: ''
            })
            $('#suggestion-container').hide();
            await this.props.createOwnSkillpath(obj);
        }
        await this.goToTopics();

    }

    closeModal = () => {
        this.setState({
            isCreate: false
        })
    }



    goBack = () => {
        this.props.history.location.state.direct && this.props.history.goBack();
        this.setState({
            isOpen: false,
            skillId: '',
            skillTitle: "",
            search: '',
            type: null
        })
    }

    goToTopics = (details) => {
        this.setState({ isOpen: false })
        this.props.history.push({
            pathname: '/manage-skillpath/topics',
            state: { id: details?._id, skill: (details ? details?.skill?.title : this.props.history.location.state.details?.title), title: details?.title || this.state.skillTitle, skillId: (details ? details?.skill?._id : this.props.history.location.state.details?._id), status: details?.draft, direct: this.props.history.location.state.direct }
        })
    }

    handleChange = (id, active) => {
        this.props.activeSkillpath(id, active);
    }

    snackClosed = () => {
        this.props.clearErrors();
        this.setState({
            successMsg: false,
            successMessageText: ''
        })
    }



    render() {
        const { isOpen, type } = this.state
        const { isSkillPathLoading, customSkillPaths, filteredSkills, theme, successEnable, successMessage, successMessageText } = this.props
        return (
            <div className='manage-skillpath-holder'>
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={successMessage}
                    onClose={() => this.snackClosed()}
                    message={successMessageText}
                    autoHideDuration={4000}
                />
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={successEnable}
                    onClose={() => this.snackClosed()}
                    message={successMessageText}
                    autoHideDuration={4000}
                />
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={this.state.successMsg}
                    onClose={() => this.snackClosed()}
                    message={this.state.successMessageText}
                    autoHideDuration={4000}
                />
                {
                    !isOpen ?
                        <Fragment>
                            <div className='d-flex justify-content-between align-items-center'>
                                <div className='d-flex align-items-center'>
                                    <p style={{ marginTop: 6, cursor: 'pointer' }} onClick={() => this.props.history.goBack()}>
                                        <img src='/images/back1.svg' alt='' width={24} />
                                    </p>&nbsp;&nbsp;
                                    <h1 className='d-flex align-items-center w-100' style={{ minHeight: 38 }}>
                                        {
                                            this.props.history.location.state.details?.title
                                        }
                                    </h1>
                                </div>
                                {window.innerWidth > 767 && <button style={{ backgroundColor: theme.bgColor }} className='custom-btn' onClick={this.state.createSkillpath ? (this.props.history.location.state.direct ? this.openSearchSkill : this.createCustom) : this.props.showWarning}>Create Custom Skill Path</button>}
                            </div>
                            <div style={{ marginTop: 6, width: window.innerWidth > 767 ? '' : '95%', borderBottom: '2px solid #e7c15f' }}></div>
                            {window.innerWidth < 767 && <button style={{ backgroundColor: theme.bgColor }} className='custom-btn w-100 mt-2' onClick={this.state.createSkillpath ? this.openSearchSkill : this.props.showWarning}>Create Custom Skill Path</button>}
                            <div className='mt-2'>

                                {isSkillPathLoading ?
                                    <TopicLoader />
                                    :
                                    customSkillPaths !== undefined && customSkillPaths?.length > 0 ? (
                                        customSkillPaths?.map((el) => {
                                            return (
                                                <div key={el._id} className="skill-list" onClick={() => this.goToTopics(el)}>
                                                    <div className="skill-items">
                                                        <div>
                                                            {window.innerWidth > 767 && (
                                                                <img
                                                                    src={el.skill?.image || '/images/sample.svg'}
                                                                    alt=""
                                                                    loading="lazy"
                                                                    width={88}
                                                                    height={56}
                                                                    style={{ verticalAlign: "middle", borderRadius: 6 }}
                                                                    onError={(e) => {
                                                                        if (
                                                                            e.target.src !==
                                                                            "https://elite-skill-images.s3.ap-south-1.amazonaws.com/Competitive+Intelligence.png"
                                                                        ) {
                                                                            e.target.onerror =
                                                                                "https://elite-skill-images.s3.ap-south-1.amazonaws.com/Competitive+Intelligence.png";
                                                                            e.target.src =
                                                                                "https://elite-skill-images.s3.ap-south-1.amazonaws.com/Competitive+Intelligence.png";
                                                                        }
                                                                    }}
                                                                />
                                                            )}{" "}
                                                            &nbsp;&nbsp;&nbsp;
                                                            <section className='text-left'>
                                                                {el.title}
                                                                {window.innerWidth > 767 && <p>Last modified: {convertToDates(el.updatedAt)}</p>}
                                                            </section>
                                                        </div>
                                                        <div className='d-flex align-items-center' style={{ width: window.innerWidth > 767 ? '50%' : '10%' }}>
                                                            {window.innerWidth > 767 &&
                                                                <Fragment>
                                                                    <div className="d-flex align-items-center" style={{ width: '33%' }}>
                                                                        <section>
                                                                            <h6>{el.videos}</h6>
                                                                            <p>Videos</p>
                                                                        </section>
                                                                    </div>
                                                                    <div className="d-flex align-items-center" style={{ width: '33%' }}>
                                                                        <section>
                                                                            <h6>{el.articles}</h6>
                                                                            <p>Articles</p>
                                                                        </section>
                                                                    </div>
                                                                    <div className="d-flex align-items-center" style={{ width: '33%' }}>
                                                                        <section>
                                                                            <h6>{el.documents}</h6>
                                                                            <p>Documents</p>
                                                                        </section>
                                                                    </div>
                                                                    <div className="d-flex align-items-center" style={{ width: '33%' }}>
                                                                        <section>
                                                                            <h6>{el.quizzes}</h6>
                                                                            <p>Quizzes</p>
                                                                        </section>
                                                                    </div>
                                                                </Fragment>
                                                            }

                                                            <div className="d-flex align-items-center" style={{ width: '50%' }}>
                                                                <section>
                                                                    <h6>{el.videos + el.articles + el.quizzes + el.documents}</h6>
                                                                    <p>Items</p>
                                                                </section>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex align-items-center" >
                                                            <p>{!el.draft ? 'Published' : 'Draft'}</p>
                                                        </div>
                                                        <div style={{ width: window.innerWidth > 767 ? '7%' : '15%', cursor: 'pointer', textAlign: 'center' }}>
                                                            {!el.draft ?
                                                                <p onClick={(e) => {
                                                                    e.preventDefault()
                                                                    e.stopPropagation()
                                                                    this.handleChange(el._id, el.active)
                                                                }}> <Switch
                                                                        onChange={(e) => console.log(e)}
                                                                        width={30}
                                                                        height={16}
                                                                        uncheckedIcon={false}
                                                                        checkedIcon={false}
                                                                        onColor='#00B24B'
                                                                        checked={el.active} /><br />
                                                                    {el.active ? 'Active' : 'Inactive'}
                                                                </p> :
                                                                ''
                                                            }

                                                            {/* <img src='/images/pencil-icon.svg' alt='' /> */}

                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <div className="empty-list">
                                            <img src="/images/empty.png" alt="" />
                                            <p>There is no customized skillpaths.</p>
                                        </div>
                                    )}
                            </div>

                        </Fragment> :

                        <div className='search-skill'>
                            <div className='search-header'>
                                <img src='/images/back.svg' alt='' style={{ cursor: 'pointer' }} onClick={() => this.goBack()} width={25} />
                                <h3>Create Custom Skill Path</h3>
                            </div>
                            <div className='search-bar'>
                                {this.props.history.location.state.direct &&
                                    <div className="has-search">
                                        <span className="form-control-feedback"><img src="/images/search.svg" width="15px" height="15px" alt="" /></span>
                                        <input id="search" autocomplete="off" className="form-control" value={this.state.search} placeholder="Search for skill to customize" onChange={(e) => this.searchSkill(e.target.value)} />
                                        {
                                            filteredSkills !== undefined &&
                                                filteredSkills.length > 0 && this.state.search !== '' ?
                                                <div id='suggestion-container' className="email-suggestion" >
                                                    <ul>
                                                        {
                                                            filteredSkills.length > 0 ?
                                                                filteredSkills.map((items, i) => {
                                                                    return (

                                                                        <li key={i} onClick={() => this.selectSkill(items)}>
                                                                            <div className="row">
                                                                                <div className="col-md-10 ">
                                                                                    {items.title}
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    )
                                                                }) : null
                                                        }
                                                    </ul>
                                                </div> : null
                                        }
                                    </div>
                                }
                                {
                                    // this.state.skillId ?
                                    <div className='mt-4'>
                                        <p>Select an option to procceed</p>
                                        <div className='d-flex align-items-center mt-2'>
                                            <div className='custom-div' style={{ pointerEvents: this.state.skillId ? 'auto' : 'none', border: this.state.type === 'own' ? '1px solid #8b7df2' : 'none' }} onClick={() => this.state.skillId ? this.selectTab('own') : ''}>
                                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_15205_51738)">
                                                        <path d="M19.2347 11.7227C17.6278 11.7227 16.1166 12.348 14.9803 13.4842C14.4122 14.0523 13.9716 14.7142 13.6734 15.4352C13.3753 16.1552 13.2188 16.9352 13.2188 17.7386C13.2188 19.3455 13.8441 20.8558 14.9803 21.992C16.1166 23.1283 17.6278 23.7536 19.2347 23.7536C20.8416 23.7536 22.3519 23.1283 23.4881 21.992C24.6244 20.8558 25.2497 19.3455 25.2497 17.7386C25.2497 16.1317 24.6244 14.6205 23.4881 13.4842C22.3519 12.348 20.8416 11.7227 19.2347 11.7227Z" fill={type === 'own' ? "#8B7DF2" : "#9D99BF"} />
                                                        <path d="M23.6053 39.3047C23.5566 38.85 23.5312 38.3887 23.5312 37.9219C23.5312 31.6622 28.0153 26.4309 33.9394 25.2712C33.9853 25.2619 34.0303 25.2534 34.0753 25.245C34.5863 25.1512 35.1066 25.0866 35.6362 25.0556C36.5212 22.4822 36.9684 20.0231 36.9684 17.7347C36.9684 7.95563 29.0128 0 19.2347 0C9.45563 0 1.5 7.95563 1.5 17.7347C1.5 20.9888 2.40281 24.5691 4.18406 28.3734C5.58 31.3566 7.51969 34.4925 9.94969 37.6959C14.0634 43.1175 18.1181 46.8234 18.2887 46.9781L19.2347 47.8378L20.1806 46.9781C20.2678 46.8984 22.0425 45.2794 24.4228 42.6347C24.225 42.1312 24.0572 41.6138 23.9231 41.0822C23.7769 40.5047 23.67 39.9103 23.6053 39.3047ZM25.4766 23.9766C23.8097 25.6444 21.5925 26.5622 19.2347 26.5622C16.8759 26.5622 14.6597 25.6444 12.9919 23.9766C11.3241 22.3097 10.4062 20.0925 10.4062 17.7347C10.4062 15.3759 11.3241 13.1597 12.9919 11.4919C13.8263 10.6575 14.7966 10.0116 15.8541 9.57375C16.9116 9.13594 18.0553 8.90625 19.2347 8.90625C21.5925 8.90625 23.8097 9.82406 25.4766 11.4919C27.1444 13.1597 28.0622 15.3759 28.0622 17.7347C28.0622 20.0925 27.1444 22.3097 25.4766 23.9766Z" fill={type === 'own' ? "#8B7DF2" : "#9D99BF"} />
                                                        <path d="M36.4219 27.8477C34.7306 27.8477 33.135 28.2667 31.7334 29.0073C28.6256 30.6461 26.4741 33.8627 26.3503 37.5845C26.3456 37.698 26.3438 37.8114 26.3438 37.9258C26.3438 43.4833 30.8644 48.0039 36.4219 48.0039C41.9794 48.0039 46.5 43.4833 46.5 37.9258C46.5 32.3683 41.9794 27.8477 36.4219 27.8477ZM42.3413 39.332H37.8281V43.8452H35.0156V39.332H30.5025V36.5195H35.0156V32.0064H37.8281V36.5195H42.3413V39.332Z" fill={type === 'own' ? "#8B7DF2" : "#9D99BF"} />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_15205_51738">
                                                            <rect width="48" height="48" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>

                                                <h1> Create own content skillpath</h1>
                                                <span>Add your own content and create a new skill path</span>
                                            </div>
                                            {this.props.history.location.state.direct &&
                                                <div className='custom-div ml-4' style={{ pointerEvents: this.state.skillId ? 'auto' : 'none', border: this.state.type === 'clone' ? '1px solid #8b7df2' : 'none' }} onClick={() => this.state.skillId ? this.selectTab('clone') : ''}>
                                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_15205_51734)">
                                                            <path d="M38.625 22.7058L45.2538 16.084C47.0248 14.3148 48 11.9623 48 9.4603C48 6.95798 47.0248 4.60544 45.2538 2.83627H45.2534C41.5986 -0.815216 35.6514 -0.815216 31.9962 2.83627C30.2252 4.60544 29.25 6.95798 29.25 9.4603C29.25 11.9623 30.2252 14.3148 31.9962 16.084L38.625 22.7058ZM38.625 7.8746C39.4017 7.8746 40.0313 8.50412 40.0313 9.28085C40.0313 10.0572 39.4017 10.6871 38.625 10.6871C37.8483 10.6871 37.2188 10.0572 37.2188 9.28085C37.2188 8.50412 37.8483 7.8746 38.625 7.8746Z" fill={type === 'clone' ? "#8B7DF2" : "#9D99BF"} />
                                                            <path d="M40.5936 33.1836H28.9686C26.4355 33.1836 24.3749 31.1229 24.3749 28.5898C24.3749 26.0568 26.4355 23.9961 28.9686 23.9961H35.9402L33.1248 21.1836H28.9686C24.8846 21.1836 21.5624 24.5059 21.5624 28.5898C21.5624 32.6735 24.8846 35.9961 28.9686 35.9961H40.5936C43.1267 35.9961 45.1874 38.0568 45.1874 40.5898V40.6836C45.1874 43.2167 43.1267 45.2773 40.5936 45.2773H14.875L12.0596 48.0898H40.5936C44.6776 48.0898 47.9999 44.7672 47.9999 40.6836V40.5898C47.9999 36.5059 44.6776 33.1836 40.5936 33.1836Z" fill={type === 'clone' ? "#8B7DF2" : "#9D99BF"} />
                                                            <path d="M18.75 33.5501C18.75 31.0478 17.7748 28.6953 16.0038 26.9261H16.0034C12.3486 23.2746 6.40137 23.2746 2.74622 26.9261C0.97522 28.6953 0 31.0478 0 33.5501C0 36.0521 0.97522 38.4046 2.74622 40.1738L9.375 46.7956L16.0038 40.1738C17.7748 38.4046 18.75 36.0521 18.75 33.5501ZM9.375 34.7769C8.59827 34.7769 7.96875 34.1471 7.96875 33.3707C7.96875 32.594 8.59827 31.9644 9.375 31.9644C10.1517 31.9644 10.7813 32.594 10.7813 33.3707C10.7813 34.1471 10.1517 34.7769 9.375 34.7769Z" fill={type === 'clone' ? "#8B7DF2" : "#9D99BF"} />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_15205_51734">
                                                                <rect width="48" height="48" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                    <h1>Create custom skill path</h1>
                                                    <span>Customize existing content for your team</span>
                                                </div>}

                                        </div>
                                    </div>
                                    // : null
                                }
                                <button className='custom-btn mt-4' style={{ opacity: (this.state.skillId && (this.state.type !== null)) ? 1 : 0.5 }} disabled={(this.state.skillId && (this.state.type !== null)) ? false : true} onClick={() => this.createCustom()}>Continue</button>
                            </div>
                            {window.innerWidth > 767 &&
                                <div style={{ height: '42%', position: 'absolute', right: 0, bottom: 0, width: '25%', marginTop: -55, backgroundPosition: "right", backgroundRepeat: "no-repeat", backgroundSize: 'contain', backgroundImage: `url('/images/custom-img.svg')` }}>
                                    {/* <img src='/images/custom-img.svg' alt='' style={{ width: '75%' }} /> */}
                                </div>
                            }
                        </div>

                }

                {/* ########## Confirm Delete modal ############### */}
                <Modal
                    show={this.state.isCreate}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    // onHide={this.handleCloseModal}
                    dialogClassName={"confirm-modal"}
                >
                    <div
                        className={
                            window.innerWidth > 767 ? "p-3 text-center" : "p-2 text-center"
                        }
                    >
                        <h1 style={{ fontSize: window.innerWidth > 767 ? 18 : 15 }}>
                            A customized skill path already exists for this skill. Do you really want to create another one?
                        </h1>
                        <div className="save-btn">
                            <div className="save-btn">
                                <button style={{ backgroundColor: theme?.bgColor }} onClick={() => this.redirectSkillTopic(this.state.type)}>Yes</button> &nbsp;&nbsp;
                                <button onClick={this.closeModal}>No</button>
                            </div>
                        </div>
                    </div>
                </Modal>

                {/* //warning modal */}
                <WarningModal
                    planAlert={this.props.alert}
                    closeSubModal={this.props.closeSubModal}
                />
            </div >
        )
    }
}

const mapStateToProps = (state) => {
    const { isSkillPathLoading, customSkillPaths, filteredSkills, customPathId } = state.manageSkillpath
    const { successMessageText, successMessage, successEnable } = state.error
    const { theme, plans, alert } = state.account
    return {
        isSkillPathLoading, customSkillPaths, filteredSkills, customPathId, theme, plans, alert, successMessageText, successMessage, successEnable
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ resetSkillPath, getPlans, getCustomSkillPath, getSkills, getSearchSkill, checkSkillPathLength, createCustomSkillpath, createOwnSkillpath, activeSkillpath, showWarning, closeSubModal, clearErrors }, dispatch)
}


export default connect(mapStateToProps, mapDispatchToProps)(ManageSkillPath)
